import React from 'react';
import { Button } from '@components/common';
import Icon from '@components/Icon/Icon';
import { useLanguage } from '@contexts/LanguageContext';
import './FormPageLayout.scss';

/**
 * Common layout component for form pages (create/edit)
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.subtitle - Page subtitle
 * @param {Function} props.onBack - Back button handler
 * @param {React.ReactNode} props.children - Form component to render
 * @param {string} props.className - Additional CSS class
 * @param {React.ReactNode} props.headerActions - Additional header actions
 */
const FormPageLayout = ({
    title,
    subtitle,
    onBack,
    children,
    className = '',
    headerActions = null
}) => {
    const { t } = useLanguage();

    return (
        <div className={`form-page-layout ${className}`}>
            <div className="page-header">
                <div className="header-actions">
                    {headerActions}
                </div>
                <h1>{title}</h1>
                {subtitle && <p>{subtitle}</p>}
            </div>

            <div className="page-content">
                <div className="form-container">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default FormPageLayout;
